import { Helmet } from "react-helmet";
import Authority from "../../components/reusables/Authority";
import SolutionCTA from "../../components/solutions/SolutionCTA";
import HowWeWork from "../../components/solutions/HowWeWork";
import SolutionItemHero from "../../components/reusables/hero/SolutionItemHero";
import EcommerceSolutions from "../../components/solutions/ecommerce/EcommerceSolutions";
import EcommerceFaqsBody from "../../components/faqs/EcommerceFaqsBody";
import RelatedEcommerce from "../../components/solutions/ecommerce/RelatedEcommerce";

export default function Ecommerce() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/ecommerce"
        />
        <meta
          name="description"
          content="High-converting online stores and e-commerce websites and apps with secure payment integrations to help you sell online and grow your business."
        />
        
        <meta
          property="og:description"
          content="High-converting online stores and e-commerce websites and apps with secure payment integrations to help you sell online and grow your business."
        />
        <meta
          property="og:title"
          content="NTUNA.COM | Solutions | Mobile App Development | Android & iOS"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />

        <meta
          name="twitter:title"
          content="NTUNA.COM | Solutions | Mobile App Development | Android & iOS"
        />
        <meta
          name="twitter:text:title"
          content="NTUNA.COM | Solutions | Mobile App Development | Android & iOS"
        />
        <meta
          name="twitter:description"
          content="High-converting online stores and e-commerce websites and apps with secure payment integrations to help you sell online and grow your business."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />
        <title>
          NTUNA.COM | E-commerce Solutions | Online Stores Website/App
        </title>
      </Helmet>
      <SolutionItemHero
        title="Online Store Website/App Development"
        subtitle="We engineer complete e-commerce systems that attract customers, convert sales, streamline operations and scale with your online store."
        casestudylink="/#"
        CTAtext="Get Free Quote"
        mainCTAlink="https://form.jotform.com/ntuna/get-free-quote"
      />
      <Authority />
      <EcommerceSolutions />
      <SolutionCTA ctaTitle="Ready To Have Your E-commerce Website/App?" />
      <EcommerceFaqsBody />
      <SolutionCTA ctaTitle="Ready To Have Your E-commerce Website/App?" />
      <HowWeWork />
      <SolutionCTA ctaTitle="Ready To Have Your E-commerce Website/App?" />
      <RelatedEcommerce />
    </>
  );
}
